import {
    FETCH_BLOCKED_USER_LIST,
    FETCH_BLOCKED_USER_LIST_START,
    FETCH_BLOCKED_USER_LIST_SUCCESS,
    FETCH_BLOCKED_USER_LIST_FAIL,
    UNBLOCK_USER,
    UNBLOCK_USER_START,
    UNBLOCK_USER_SUCCESS,
    UNBLOCK_USER_FAIL
} from 'actions/ActionTypes';

import { gcApi } from 'config/axios';
import { takeEvery, call, put, fork } from 'redux-saga/effects';

import { fetchMultipleUserSocialProfileImage } from 'actions/userSocialProfileImageActions';

export function* fetchBlockedUserList() {
    try {
        yield put({
            type: FETCH_BLOCKED_USER_LIST_START
        });

        // swagger: https://connectapitest-swagger.garmin.com/?urls.primaryName=userblock-service#/default/getBlockingList_1
        const response = yield call(gcApi.get, '/userblock-service/blockuser');

        yield put({
            type: FETCH_BLOCKED_USER_LIST_SUCCESS,
            blockedUserList: response.data
        });

        yield fork(fetchBlockedUserListProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_BLOCKED_USER_LIST_FAIL
        });
    }
}

export function* unblockUser(action) {
    const { displayName } = action.payload;
    try {
        yield put({
            type: UNBLOCK_USER_START
        });

        yield call(gcApi.delete, `/userblock-service/blockuser/${displayName}`);

        yield put({
            type: UNBLOCK_USER_SUCCESS
        });
    } catch (e) {
        yield put({
            type: UNBLOCK_USER_FAIL
        });
    }
}

/**
 * handle muted connection list
 * @param {Object[]} responseData
 * @param {number} responseData[].userProfileId
 * @returns
 */
function* fetchBlockedUserListProfileImageAndFrameSaga(responseData) {
    if (!responseData?.length) {
        return;
    }
    const userIds = responseData?.map((item) => item.userProfileId);
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

function* fetchProfileImageAndFrameSaga(userIds) {
    if (!userIds || !userIds.length) {
        return;
    }
    yield put(fetchMultipleUserSocialProfileImage(userIds));
}

export const blockUserSagas = [
    takeEvery(FETCH_BLOCKED_USER_LIST, fetchBlockedUserList),
    takeEvery(UNBLOCK_USER, unblockUser)
];
